var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"zlkz"}},[_c('MainHeader',{attrs:{"cState":"数据中心"}}),_c('div',{staticClass:"main"},[_c('NavLeft',{attrs:{"cState":"质量控制"}}),_c('div',{staticClass:"rightWrap"},[_c('PatientList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }